<div class="flex flex-col items-center gap-16 px-36 py-20 md:gap-10 md:px-6 md:py-8">
    <div
        class="malou-card flex h-full w-1/2 justify-center rounded-[20px] bg-malou-blue px-8 py-10 sm:!px-5 md:h-fit md:px-5 md:py-6 lg:px-14">
        <div class="malou-card__header mb-8 flex flex-col !items-start md:mb-2">
            <p class="malou-text-18--bold text-malou-white">{{ 'auth.login.welcome' | translate }}</p>

            <p class="malou-text-14 text-malou-white opacity-70">{{ 'auth.login.text' | translate }}</p>
        </div>

        <div class="malou-card__body flex flex-col justify-center" [formGroup]="loginFormGroup">
            <input
                class="malou-text-12--medium malou-input"
                type="text"
                formControlName="email"
                [placeholder]="'auth.login.email' | translate"
                [class.italic]="!email" />
            <div class="flex items-center gap-2">
                <input
                    class="malou-text-12--medium malou-input !mb-0 pb-0"
                    formControlName="password"
                    [type]="isPasswordVisible() ? 'text' : 'password'"
                    [placeholder]="'auth.login.password' | translate" />
                <mat-icon
                    class="!h-8 !w-8 cursor-pointer text-malou-white"
                    [svgIcon]="isPasswordVisible() ? SvgIcon.EYE_CLOSED : SvgIcon.EYE"
                    (click)="changePasswordVisibility()"></mat-icon>
            </div>

            <div class="flex justify-center">
                <button
                    class="mt-12 w-1/2 !bg-malou-primary text-malou-white disabled:!text-malou-white md:w-full"
                    mat-flat-button
                    [disabled]="loginFormGroup.invalid"
                    [ngClass]="{ 'cursor-not-allowed opacity-50': loginFormGroup.invalid }"
                    (click)="onSubmit()">
                    {{ 'auth.login.submit' | translate }}
                </button>
            </div>
        </div>
    </div>
</div>
